<template>
	<h-radio-group
		v-model="imageType"
		:aria-label="t('images-type')"
		class="flex items-center space-x-0.5 rounded-2xs bg-gray-100 p-1"
	>
		<!-- Model images -->
		<h-radio-group-option v-slot="{checked}" as="template" value="model">
			<button
				ref="modelButton"
				type="button"
				:aria-label="t('images-model')"
				:title="`${t('images-type')}: ${t('images-model')}`"
				class="ring-focus flex cursor-pointer items-center rounded-2xs px-1 transition-colors outline-hidden focus:ring-black focus:ring-offset-2"
				:class="{
					'bg-white text-black': checked,
					'text-gray-400': !checked,
				}"
				@click.stop="selectModel(checked)"
			>
				<v-icon icon="lamp-floor" class="w-[10px]" />

				<v-icon icon="couch" class="size-[2em]" />
			</button>
		</h-radio-group-option>

		<!-- Cutout images -->
		<h-radio-group-option v-slot="{checked}" as="template" value="cutout">
			<button
				ref="cutoutButton"
				type="button"
				:aria-label="t('images-cutout')"
				:title="`${t('images-type')}: ${t('images-cutout')}`"
				class="ring-focus relative flex cursor-pointer items-center rounded-2xs px-1 transition-colors outline-hidden focus:ring-black focus:ring-offset-2"
				:class="{
					'bg-white text-black': checked,
					'text-gray-400': !checked,
				}"
				@click.stop="selectCutout(checked)"
			>
				<v-icon icon="couch" class="size-[2em]" />
			</button>
		</h-radio-group-option>
	</h-radio-group>
</template>

<script lang="ts" setup>
import {usePreferredProductImageType} from "@pkg/shared/composables/use-preferred-product-image-type";

const {t} = useI18n();

const imageType = usePreferredProductImageType();

const modelButton = ref<HTMLButtonElement>();
const cutoutButton = ref<HTMLButtonElement>();

function selectModel(checked: boolean) {
	imageType.value = checked ? "cutout" : "model";
	if (checked) nextTick(() => cutoutButton.value?.focus());
}

function selectCutout(checked: boolean) {
	imageType.value = checked ? "model" : "cutout";
	if (checked) nextTick(() => modelButton.value?.focus());
}
</script>

<i18n lang="json">
{
	"et": {
		"images-type": "Tootepiltide stiil",
		"images-model": "Toode ruumis",
		"images-cutout": "Ainult toode"
	},
	"fi": {
		"images-type": "Tuotekuvien tyyli",
		"images-model": "Tuote huoneessa",
		"images-cutout": "Vain tuote"
	}
}
</i18n>
